import { ChangeDetectionStrategy, Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, AfterViewInit, HostListener, trigger, state, style, transition, animate, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PagesIndexComponent } from '../enrichmentTabs/enrichmentTabPopups/pagesIndex/pagesIndex.component';
import { AddEnrichmentOptionsComponent } from '../enrichmentTabs/enrichmentTabPopups/AddEnrichmentOptions/addEnrichmentOptions.component';
import { MatIconRegistry } from '@angular/material';
import { ParentviewComponent } from '../enrichmentTabs/enrichmentTabPopups/parentview/parentview.component'
import { Constants } from '../../shared/models/constants';
import { BookData } from '../../shared/models/bookData';
import { Page } from '../../shared/models/page';
import { EnrichmentPage } from '../../shared/models/enrichmentPage';
import { Book } from '../../shared/models/book';
import { EnrichmentTabsService } from './enrichmentTabs.service';
import { PageContent } from '../../shared/models/pageContent';
import { LiquidModel } from '../../shared/models/liquidModel';
import * as _ from 'lodash';
import { CreateTemplateDialogueComponent } from '../popups/create-template-dialogue/create-template-dialogue.component';
import { PageTemplate } from '../../shared/models/pageTemplate';
import { EBEpouchdbService } from '../../EBE/EBEpouchdb.service';
import { LoginObservableService } from '../../shared/loginObservable.service';
import { IS_ElectronService } from '../../shared/IS_Electron.service';

@Component({
  selector: 'app-enrichmentTabs',
  templateUrl: './enrichmentTabs.component.html',
  styleUrls: ['./enrichmentTabs.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class EnrichmentTabsComponent implements OnInit {

  addTabtype;
  @Input() bookObj: Book;
  @Input() bookDataObj: BookData;
  @Input() pageObj: Page;

  @Input() parent;
  @Output() notify: EventEmitter<any> = new EventEmitter<string>();
  @Output() updateLength: EventEmitter<any> = new EventEmitter<string>();
  reloadEnrichments = true;

  showEnrichTabs = true;
  CurrentSelectedObj;
  displayList = false;
  activeSublevelIndex;
  activeCurrentLoadingPage = false;
  allBooksList;
  displayChildsOnSelection = false;
  currentLoadingPage;
  public tabsList = [];
  public firstLevel_selectedTabIndex;
  parentItems = [];

  public tabAttachType: any;
  public rootTabActive: boolean = true;
  public pagesObj: any;
  public currentPageNumber: any = 1;
  public popupPageOptions;
  public currentSelectedParentObj;
  firstLevelSortedElements;
  secondLevelSortedElements;
  public enrichmentOptions = {};
  firstlevelDragItem;
  firstLevelDragIndex;
  public renameFirstLevelTabIndex: any;
  public renameSecondLevelTabIndex: any;
  public renameModel;
  epageContent: any;
  public pageIndex: any = 1;
  // public bookDataObj: BookData;
  public el;
  public el2;
  public sortedOrder = [];
  public pageContentModel;
  canvaspdfHeight;
  canvaspdfWidth;

  constructor(private ele: ElementRef, private cdr: ChangeDetectorRef, private pouchService: EnrichmentTabsService, public dialog: MatDialog, private EBEpouchdbService: EBEpouchdbService, private LoginObservableService: LoginObservableService, private ElectronService: IS_ElectronService) {

    this.enrichmentOptions = Constants.getEnrichmentOptions();

    this.pouchService.pageContentData$.subscribe(evt => {
      this.setPageConent(evt);
    });
  }

  @HostListener('window:resize') onResize() {
    this.loadFirstLevelChromeTabs();
  }

  setPageConent(data) {
    this.pageContentModel = data;
    this.epageContent = data.pageContent;
    this.emitCallback();
  }

  internetSearchObj: any = {
    showPopup: false
  }

  youtubeSearchObj: any = {
    showPopup: false
  }

  googleServicesObj: any = {
    showPopup: false,
    googleServiceType: ""
  }

  pageFromBookObj: any = {
    showPopup: false,
    bookObj: this.bookObj
  }

  templateAsEnrichmentObj: any = {
    showPopup: false
  }

  ngOnInit() {
    document['enrichTabs'] = this;
    if (this.bookDataObj) {
      this.currentPageNumber = this.bookDataObj.lastOpenedPage + "";
      // if (this.pageObj) {
      if (this.bookDataObj[this.currentPageNumber]) {
        // this.tabsList = this.pageObj.enrichment_page;
        this.tabsList = this.bookDataObj[this.currentPageNumber].enrichment_page;
      }

      if (this.parent == 'ELE') {

        if (this.pageObj) {
          this.tabsList = this.pageObj.enrichment_page;
          this.pageIndex = this.pageObj.pageNumber;
        }
      }
      else if (this.parent == 'CreatedEBE') {
        this.pageIndex = (this.bookDataObj.pages.indexOf(this.bookDataObj.lastOpenedPage));
      }
      else this.pageIndex = this.bookDataObj.lastOpenedPage;

    }
  }

  //To set the Add tab button left position
  setAddTabLeftPos() {
    //243px is each tab width
    //14px is tab overlap distance
    //38px is width of add button
    //243px is the width of root tab
    //8px is margin left for first level tabs container
    //12px is the padding of the chrome tabs element
    //5px is offset value

    if (this.tabsList.length == 1) {
      document.querySelector('.addTabButton')['style'].left = (this.tabsList.length * 243) + 'px';
    }
    else if (this.tabsList.length == 0) {
      document.querySelector('.addTabButton')['style'].left = 0 + 'px';
    }
    else {
      var addTabpos = (this.tabsList.length * 243) - (14 * (this.tabsList.length - 1)) + 38 + 243 + 8 + 12;
      if (addTabpos < window.innerWidth) {
        document.querySelector('.addTabButton')['style'].left = addTabpos - 243 - 8 - 38 - 12 + "px";
      }
      else {
        document.querySelector('.addTabButton')['style'].left = document.querySelector('.chrome-tabs-content')['offsetWidth'] - 5 + "px";
      }
    }
  }

  setSecondLevelAddTabLeftPos() {
    //180.5px is width of current selected root including margin on both sides
    //34px is width of up-arrow including margin on both sides
    //12px is the padding of the padding of the second level tabs container
    //14px is the taboverlap distance
    //243px is each tab width
    //38px is width of add button
    //12px is offset value
    if (this.CurrentSelectedObj.children.length == 1) {
      this.el2.querySelector('.addTabButton')['style'].left = '229px'; // 243px - 14px where 14 px is taboverlap distance
    }
    else {
      var secondLevelAddTabpos = (this.CurrentSelectedObj.children.length * 243) - (14 * (this.CurrentSelectedObj.children.length - 1)) + 180.5 + 34 + 12 + 38;
      if (secondLevelAddTabpos < window.innerWidth) {
        this.el2.querySelector('.addTabButton')['style'].left = secondLevelAddTabpos - 180.5 - 34 - 12 - 38 - 12 + "px";
      }
      else {
        this.el2.querySelector('.addTabButton')['style'].left = this.el2.querySelector('.chrome-tabs-content')['offsetWidth'] - 12 + "px";
      }
    }
  }


  ngAfterViewInit() {
    this.loadFirstLevelChromeTabs();
  }

  setupEventHandlers(elem) {

    var ref = this;

    //When tabs get sorted
    elem.addEventListener('catchTabEls', function (event) {
      ref.sortedOrder = [];
      for (var i = 0; i <= event['detail'].length; i++) {
        if (event['detail'][i]) {
          ref.sortedOrder.push(event['detail'][i].getAttribute('data-id'));
        }
      }
      if (elem.classList.contains('chrome-tabs-secondLevel')) {

        //To avoid repeated execution of code due to repeated calling of addEventListener
        let arr1 = [];
        for (var b = 0; b <= ref.CurrentSelectedObj.children.length; b = b + 1) {
          if (ref.CurrentSelectedObj.children[b]) {
            arr1.push(ref.CurrentSelectedObj.children[b].id.toString());
          }
        }
        if (_.isEqual(ref.sortedOrder, arr1)) {
          return;
        }
        //

        ref.CurrentSelectedObj.children = ref.mapOrder(ref.CurrentSelectedObj.children, ref.sortedOrder, 'id');
        ref.setSecondLevelTabIndex();
        ref.saveEnrichments();
      }
      else {
        ref.tabsList = ref.mapOrder(ref.tabsList, ref.sortedOrder, 'id');
        ref.setFirstLevelTabIndex();
        ref.saveEnrichments();
      }
    });

    elem.addEventListener('activeTabChange', function (event) {
      if (event['target'].classList.contains('chrome-tabs')) {
        ref.setFirstLevelTabIndex();
      }
      else {
        ref.setSecondLevelTabIndex();
      }
    });

    //To show tab optns popup
    elem.addEventListener('showTabOptnsPopup', function (event) {
      if (event['detail']) {
        if (event['detail'].currentTarget.parentElement.parentElement.parentElement.classList.contains('chrome-tabs')) {
          ref.showGlobalpopup(event['detail'], 'firstLevelChild');
        }
        else {
          ref.showGlobalpopup(event['detail'], 'secondLevelChild');
        }
      }
    });

    //On child count click
    elem.addEventListener('onChildLengthClick', function (event) {
      if (event['detail']) {
        if (event['detail'].currentTarget.parentElement.parentElement.parentElement.classList.contains('chrome-tabs')) {
          ref.goToChildTabsList(event['detail'], ref.tabsList[ref.firstLevel_selectedTabIndex], false, ref.firstLevel_selectedTabIndex)
        }
        else {
          if (ref.activeSublevelIndex != undefined && ref.CurrentSelectedObj.children[ref.activeSublevelIndex]) {
            ref.goToChildTabsList(event['detail'], ref.CurrentSelectedObj.children[ref.activeSublevelIndex], true, ref.activeSublevelIndex);
          }
        }
      }
    });

    elem.addEventListener('chromeTabTitleUpdated', function (event) {
      if (ref.addTabtype == "firstLevelChild") {
        ref.tabsList[ref.firstLevel_selectedTabIndex].title = event['detail'];
      }
      else {
        ref.CurrentSelectedObj.children[ref.activeSublevelIndex].title = event['detail'];
      }
      ref.saveEnrichments();
    });
  }

  //To select first level tab and set first level index
  setFirstLevelTabIndex() {
    let idd = this.getCurrentChromeTabId();
    var currntObj = this.tabsList.filter(function (obj) {
      return obj.id.toString() == idd;
    });
    if (currntObj[0] && currntObj[0].level == 0) {
      var inddd = this.tabsList.findIndex(obj => obj.id.toString() === idd);
      this.selectFirstLevelTab(currntObj[0], inddd);
    }
  }

  //To select second level tab and set second level index
  setSecondLevelTabIndex() {
    let tempId = this.el2.querySelector('.chrome-tab-current').getAttribute('data-id');
    let currntObj = this.CurrentSelectedObj.children.filter(function (obj) {
      return obj.id.toString() == tempId;
    });
    if (currntObj[0]) {
      let inddd = this.CurrentSelectedObj.children.findIndex(obj => obj.id.toString() === tempId);
      this.secondLevelTabsClick(inddd, currntObj[0]);
    }
  }

  async onEnrichmentCallBack(message) {
    this.tabHandling();

    if (message.type == "pageFromBook" || message.type == "googleDocs" || message.type == "spreadSheet" || message.type == "presentation") {
      if (message.selectedThumbs.length > 1) {
        for (var i = 0; i < message.selectedThumbs.length; i = i + 1) {
          let obj = this.enrichmentOptions[message.type];
          if (message.type == "pageFromBook") {
            obj.url = message.selectedThumbs[i].url;
          }
          else {
            obj.text = message.selectedThumbs[i].title;
            obj.url = message.selectedThumbs[i].embedLink;
          }
          console.log("In onEnrichmentCallBack, tabAttachType - " + this.tabAttachType);
          await this.addTab(obj);

          if (this.tabAttachType == "addChildren") {
            this.tabAttachType = "";
            this.addTabtype = "secondLevelGlobal";
          }
        }
      }
      else {
        let obj = this.enrichmentOptions[message.type];
        if (message.type == "pageFromBook") {
          obj.url = message.selectedThumbs[0].url;
        }
        else {
          obj.text = message.selectedThumbs[0].title;
          obj.url = message.selectedThumbs[0].embedLink;
        }
        this.addTab(obj);
      }
    }
    else if (message.type == "template") {
      if (message.selectedThumbs.length > 1) {
        for (var i = 0; i < message.selectedThumbs.length; i = i + 1) {
          let obj = this.enrichmentOptions[message.type];
          obj.contentDocId = message.selectedThumbs[i].contentDocId;
          await this.addTab(obj);

          if (this.tabAttachType == "addChildren") {
            this.tabAttachType = "";
            this.addTabtype = "secondLevelGlobal";
          }
        }
      }
      else {
        let obj = this.enrichmentOptions[message.type];
        obj.contentDocId = message.selectedThumbs[0].contentDocId;
        this.addTab(obj);
      }
    }
    else {
      this.addTab(message);
    }
  }

  //To sort the tabsList array
  mapOrder(array, order, key) {
    array.sort(function (a, b) {
      var A = a[key].toString(),
        B = b[key].toString();
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return array;
  };

  getCurrentChromeTabId() {
    return this.el.querySelector('.chrome-tab-current').getAttribute('data-id');
  }

  addTabButtonClick(evt) {
    let appFeature: any;
    ////In APP Feature/////
    if (this.parent == "ELE") {
      appFeature = "Create_Ele_Tabs";
    }
    else if (this.parent == "createdEBE" || this.parent == "EBE") {
      appFeature = "Create_Pdf_Tabs";
    }
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable(appFeature);
    if (isFeatureAvailable == 'false') {
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }
    //////////
    if (evt.currentTarget.classList.contains('parallelogram2')) {
      this.showGlobalpopup(evt, 'secondLevelGlobal');
    }
    else {
      this.showGlobalpopup(evt, 'firstLevelGlobal');
    }
  }

  addChromeTab(obj, addType, level, makeTabActive) {

    var iconType = this.getIcon(obj)
    var iconColor = this.getColor(obj);

    if (level == 'firstLevel') {
      document['chromeTabs'].addTab({
        title: obj.title,
        favicon: iconType,
        dataid: obj.id,
        addType: addType,
        color: iconColor,
        childLength: obj.children.length,
        makeTabActive: makeTabActive
      })
    }
    else {
      document['chromeTabs2'].addTab({
        title: obj.title,
        favicon: iconType,
        dataid: obj.id,
        addType: addType,
        color: iconColor,
        childLength: obj.children.length,
        makeTabActive: makeTabActive
      })
    }

    var ref = this;
    setTimeout(() => {
      if (obj.level > 0) {
        ref.setSecondLevelAddTabLeftPos()
      }
      else {
        ref.setAddTabLeftPos();
      }
    }, 0);
  }

  removeChromeTab(level) {
    if (level == 'firstLevel') {
      document['chromeTabs'].removeTab(this.el.querySelector('.chrome-tab-current'));
      setTimeout(() => {
        this.setAddTabLeftPos();
      }, 0);
    }
    else {
      document['chromeTabs2'].removeTab(this.el2.querySelector('.chrome-tab-current'));
      setTimeout(() => {
        this.setSecondLevelAddTabLeftPos();
      }, 0);

      if (this.CurrentSelectedObj.children[this.activeSublevelIndex] && this.CurrentSelectedObj.children[this.activeSublevelIndex].level == 1) {
        document['chromeTabs'].showChildrenCount(this.CurrentSelectedObj.children.length);
      }
      else if (this.CurrentSelectedObj.children.length == 0) {
        document['chromeTabs'].hideChildrenCount();
      }
    }
  }

  async prepareBookdataObj(pageObj) {
    if (this.parent != 'ELE') {
      if (!this.bookDataObj[this.currentPageNumber]) {
        pageObj.pageNumber = this.currentPageNumber;
        pageObj.title = "Page " + this.currentPageNumber;
        this.bookDataObj[this.currentPageNumber] = pageObj;
        this.bookDataObj.pages.push(this.currentPageNumber);
      }
      this.bookDataObj[this.currentPageNumber].enrichment_page = this.tabsList;

    }
    await this.pouchService.update(this.currentPageNumber, this.bookDataObj);

    this.updateLength.emit(this.bookDataObj);
  }

  async saveEnrichments() {
    if (this.tabsList) {
      var pageObj = new Page();
      await this.prepareBookdataObj(pageObj);
    }
  }

  getEnrichmentPagesFromEleComp(list) {
    this.tabsList = list.enrichment_page;
  }

  updateTabs(currentPageNumber, index, pageobj) {
    console.log("currentPageNumber:" + currentPageNumber);
    this.bookDataObj.lastOpenedPage = currentPageNumber;
    this.currentPageNumber = currentPageNumber;
    if (this.parent == 'CreatedEBE' || this.parent == 'ELE') {
      this.pageIndex = index;
    }
    else {
      this.pageIndex = parseInt(this.currentPageNumber);
    }
    this.tabsList = [];
    this.currentLoadingPage = undefined;
    this.rootTabActive = true;
    this.CurrentSelectedObj = undefined;
    this.currentSelectedParentObj = undefined;
    // if (this.bookDataObj && this.bookDataObj[this.currentPageNumber])
    //   this.tabsList = this.bookDataObj[this.currentPageNumber].enrichment_page;
    if (pageobj) {
      this.tabsList = pageobj.enrichment_page;
      this.pageObj = pageobj;
    }


    // this.pouchService.getEnrichmentTabs(this.bookObj, this);
    this.loadFirstLevelChromeTabs();
    this.cdr.detectChanges();
  }

  updateTabsMindmap(pageobj, bookdata) {

    this.bookDataObj = bookdata;
    this.reloadEnrichments = false;

    setTimeout(() => {

      this.reloadEnrichments = true;
      this.tabsList = [];
      this.currentLoadingPage = undefined;
      this.rootTabActive = true;
      this.CurrentSelectedObj = undefined;
      this.currentSelectedParentObj = undefined;

      // if (this.parent != 'EBE') {
      //   if (this.bookDataObj.pages.indexOf(this.currentPageNumber.toString()) == -1)
      //     this.currentPageNumber = this.bookDataObj.pages[this.currentPageNumber - 1]
      // }

      this.tabsList = pageobj.enrichment_page;
      this.loadFirstLevelChromeTabs();
      // this.saveEnrichments();

      this.pouchService.update(this.currentPageNumber, this.bookDataObj);
      this.updateLength.emit(this.bookDataObj);
      this.cdr.detectChanges();

    }, 10);


  }

  callBack(obj, tabAttachType) {

    // this.rootTabActive = false;
    this.tabAttachType = tabAttachType;

    if (obj && obj.type) {
      switch (obj.type) {
        case "internet":
          this.internetSearchObj.showPopup = true;
          break;
        case "youtube":
          this.youtubeSearchObj.showPopup = true;
          break;
        case "spreadSheet":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "googleDocs":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "presentation":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "pageFromBook":
          this.pageFromBookObj.showPopup = true;
          this.pageFromBookObj.bookObj = this.bookObj
          break;
        case "template":
          this.templateAsEnrichmentObj.showPopup = true;
          break;
        default:
          this.tabHandling();
          this.addTab(obj);
          break;
      }
      return;
    }
    else {
      this.tabHandling();
      if (obj) {
        this.addTab(obj);
      }
    }
  }

  renameFieldClick(evt) {
    evt.stopPropagation();
  }

  tabHandling() {
    //Delete
    if (this.tabAttachType == "delete") {
      this.deleteTab();
      return;
    }
    //Rename
    else if (this.tabAttachType == "edit") {
      if (this.addTabtype == "firstLevelChild") {
        document['chromeTabs'].renameChromeTabTitle(this.tabsList[this.firstLevel_selectedTabIndex].title);
      }
      else {
        document['chromeTabs2'].renameChromeTabTitle(this.CurrentSelectedObj.children[this.activeSublevelIndex].title);
      }
      return;
    }
    else if (this.tabAttachType == "saveAsTemplate") {
      this.openDialog();
      return;
    }
    else if (this.addTabtype == "firstLevelGlobal" || this.addTabtype == "firstLevelChild") {
      this.CurrentSelectedObj = this.tabsList[this.firstLevel_selectedTabIndex];
      this.currentSelectedParentObj = {};
      this.parentItems = [];
    }
    else if (this.addTabtype == "secondLevelChild") {
      if (this.tabAttachType == "addChildren") {
        this.currentSelectedParentObj = this.CurrentSelectedObj;
        this.CurrentSelectedObj = this.CurrentSelectedObj.children[this.activeSublevelIndex];
      }
    }
  }

  deleteTab() {

    if (this.addTabtype == "firstLevelChild") {
      this.tabsList.splice(this.firstLevel_selectedTabIndex, 1);
      if (!this.tabsList[this.firstLevel_selectedTabIndex]) {
        if (this.firstLevel_selectedTabIndex > 0) {
          this.firstLevel_selectedTabIndex = this.firstLevel_selectedTabIndex - 1;
        }
      }
      this.CurrentSelectedObj = this.tabsList[this.firstLevel_selectedTabIndex];
      this.currentLoadingPage = this.CurrentSelectedObj;
      this.removeChromeTab('firstLevel');
      if (this.tabsList.length == 0) {
        this.rootTabClick(undefined);
      }
    }
    else if (this.addTabtype == "secondLevelChild") {
      this.CurrentSelectedObj.children.splice(this.activeSublevelIndex, 1);
      this.updateParentItems();
      if (this.CurrentSelectedObj.children.length == 0) {
        if (this.parentItems.length - 1 > 0) {
          this.parentItems = this.parentItems.slice(0, this.parentItems.length - 1);
          this.CurrentSelectedObj = this.parentItems[this.parentItems.length - 1];
          if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
          }
          this.loadSecondLevelChromeTabs(0);
        }
        else {
          this.CurrentSelectedObj = this.parentItems[0];
          this.parentItems = [];
          this.currentLoadingPage = this.CurrentSelectedObj;
          document['chromeTabs'].hideChildrenCount();
        }
      }
      else {
        if (!this.CurrentSelectedObj.children[this.activeSublevelIndex]) {
          this.activeSublevelIndex = this.activeSublevelIndex - 1;
        }
        this.currentLoadingPage = this.CurrentSelectedObj.children[this.activeSublevelIndex];
        this.removeChromeTab('secondLevel');
      }

    }

    this.emitCallback();

    this.saveEnrichments();
  }

  // updateTabName(tab) {
  //   tab.title = this.renameModel;
  //   this.renameFirstLevelTabIndex = undefined;
  //   this.renameSecondLevelTabIndex = undefined;
  //   this.saveEnrichments();
  //   this.renameModel = "";
  // }

  emitCallback() {
    //Output
    this.notify.emit(
      {
        epageContent: this.epageContent,
        enrichmentTabs: this.tabsList,
        currentLoadingPage: this.currentLoadingPage,
        rootTabActive: this.rootTabActive

      });
  }

  popupParams: any = {
    height: 300,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    loadDirective: "",
    curComp: this
  };
  globalPopupPara = <any>{};

  ///
  showGlobalpopup(ev, addTabtype) {

    this.cdr.detectChanges();
    this.addTabtype = addTabtype;

    if (addTabtype == "firstLevelGlobal") {
      // if (this.parent == 'ELE' || this.parent == 'CreatedEBE') {
      //   this.popupParams.height = "256";
      // } else {
      //   this.popupParams.height = "299";
      // }
      this.popupParams.height = "256";
    } else if (addTabtype == "firstLevelChild") {
      this.popupParams.height = "257";
    } else if (addTabtype == "secondLevelGlobal") {
      this.popupParams.height = "256";
    } else {
      this.popupParams.height = "257";
    }

    if (ev.clientX + 90 > window.innerWidth) {
      this.popupParams.arrowPos = 150;
    }
    else {
      this.popupParams.arrowPos = 100;
    }

    this.popupParams.width = "182";
    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    this.globalPopupPara.direction = "top";

    this.globalPopupPara.curComp = this;
    this.globalPopupPara.loadDirective = AddEnrichmentOptionsComponent;

    this.cdr.detectChanges();
  }

  rootTabClick(ev) {
    this.firstLevel_selectedTabIndex = undefined;
    this.currentLoadingPage = undefined;
    //To remove chrome tab selection
    document['chromeTabs'].removeCurrentChromeTabSelection();

    //To hide the second level tabs
    this.displayChildsOnSelection = false;

    if (this.rootTabActive == false) {
      this.rootTabActive = true;
      this.emitCallback();
      return;
    }

    if (this.parent != 'ELE' && this.parent != 'CreatedEBE' && ev) {
      this.popupParams.arrowPos = 85;
      this.popupParams.width = "210";
      this.popupParams.height = "400";
      this.globalPopupPara = this.popupParams;
      this.globalPopupPara.showPopup = true;
      this.globalPopupPara.ev = ev;

      this.globalPopupPara.direction = "top";
      this.globalPopupPara.bookDataObj = this.bookDataObj;
      this.globalPopupPara.pageCount = this.bookObj.pageCount;
      this.globalPopupPara.loadDirective = PagesIndexComponent;
      this.globalPopupPara.loadPagesIndexComponent = true;

      this.emitCallback();
    }

  }

  //get icon
  getIcon(tabObj) {
    return this.enrichmentOptions[tabObj.type].icon;
  }

  //get color
  getColor(tabObj) {
    return this.enrichmentOptions[tabObj.type].color;
  }

  //test purpose - Added for new implementation to update parentItems array
  updateParentItems() {
    var ref = this;
    let tempInd = _.findIndex(this.parentItems, function (o) { return o.id == ref.CurrentSelectedObj.id });
    if (tempInd != -1) {
      //To update CurrentSelectedObj in parentItems array
      this.parentItems.splice(tempInd, 1);
      this.parentItems.splice(tempInd, 0, this.CurrentSelectedObj);
      //To update CurrentSelectedObj in its parent in the parentItems array
      if (tempInd > 0) {
        let ind = _.findIndex(this.parentItems[tempInd - 1].children, function (o) {
          return o['id'] == ref.CurrentSelectedObj.id
        })
        if (ind != -1) {
          this.parentItems[tempInd - 1].children.splice(ind, 1);
          this.parentItems[tempInd - 1].children.splice(ind, 0, this.CurrentSelectedObj);
        }
      }
    }
  }

  //Add tabs
  public async addTab(tabData) {

    this.rootTabActive = false;
    this.activeCurrentLoadingPage = false;
    let enrichmentObj = new EnrichmentPage();
    enrichmentObj.id = Constants.getGUID();
    enrichmentObj.type = tabData.type;
    switch (tabData.type) {
      case "blankPage":
        this.updatePageContent(enrichmentObj, undefined);
        break;
      case "youtube":
        enrichmentObj.description.url = "https://www.youtube.com/embed/" + tabData.videoId;
        enrichmentObj.description.key = tabData.videoId;
        break;
      case "internet":
        enrichmentObj.description.url = tabData.url;
        if (tabData.title.length > 0) {
          enrichmentObj.description.key = tabData.title;
        }
        break;
      case "spreadSheet":
      case "googleDocs":
      case "presentation":
        enrichmentObj.description.url = tabData.url;
        break;
      case "pageFromBook":
        await this.updatePageContentWithUrl(enrichmentObj, tabData.url);
        break;
      case "duplicateAsImage":
        this.duplicateAsImageOfPdf(tabData, enrichmentObj);
        break;
      case "duplicateAsPage":
        enrichmentObj.type = this.pageObj.type;
        this.updatePageContentWithPage(enrichmentObj);
        break;
      case "template":
        await this.updatePageContent(enrichmentObj, tabData.contentDocId);
        break;
      default:
        break;
    }

    if (tabData.type != "duplicateAsImage") {
      this.addingTabs(tabData, enrichmentObj);
    }

  }

  public addingTabs(tabData, enrichmentObj) {

    if (this.tabAttachType == "addSiblingLeft" || this.tabAttachType == "addSiblingRight") {
      this.addSiblingTabs(tabData, enrichmentObj);
    } else if (this.tabAttachType == "addChildren") {
      this.addChildTabs(tabData, enrichmentObj);
    } else if (this.addTabtype == "firstLevelGlobal" || this.addTabtype == "secondLevelGlobal") {
      this.addGlobalLevelTabs(tabData, enrichmentObj);
    }

    this.currentLoadingPage = enrichmentObj;
    this.displayChildsOnSelection = true;

    //To maintain second level tabs index
    if (this.CurrentSelectedObj && this.CurrentSelectedObj.children.length) {
      this.activeSublevelIndex = this.CurrentSelectedObj.children.indexOf(enrichmentObj);
    }

    this.updateParentItems();
    // this.emitCallback();
    this.saveEnrichments();

  }

  async updatePageContent(enrichmentObj, id) {
    var pageContent: PageContent = new PageContent();
    pageContent._id = Constants.USER + "." + enrichmentObj.id + ".pageContent";
    pageContent.bookDocId = this.bookDataObj.bookDocId;
    enrichmentObj.contentDocId = pageContent._id;
    if (!id) {
      this.epageContent = pageContent.pageContent;
      await this.pouchService.createPageContentDoc(pageContent);
    }
    else {
      var self = this;
      await this.pouchService.getTemplatePageContent(id).then(async function (res) {
        if (res) {
          pageContent.pageContent = res['pageContent']
          await self.pouchService.createPageContentDoc(pageContent);
          await self.setPageConent(res);
        }
      });
    }
  }



  duplicateAsImageOfPdf(tabData, enrichmentObj) {
    if (this.ElectronService.IS_ELECTRON) {
      var CANVAS: any = document.createElement('canvas');

      CANVAS.width = this.pouchService.pdfDoc.cWidth;
      CANVAS.height = this.pouchService.pdfDoc.cHeight;
      CANVAS.style.position = "absolute";
      var CANVAS_CTX = CANVAS.getContext('2d');
      let that = this;
      let page_no = parseInt(this.currentPageNumber);
      this.pouchService.pdfDoc.pdf.getPage(page_no).then(function (page) {
        var scale_required = CANVAS.width / page.getViewport(1).width;
        var viewport = page.getViewport(scale_required);
        CANVAS.height = viewport.height;

        var task = page.render({ canvasContext: CANVAS_CTX, viewport: viewport })
        task.promise.then(async function () {
          var dataURL = CANVAS.toDataURL();
          var base64Url = dataURL.replace('data:image/png;base64,', '');
          console.log(base64Url);
          let title = Math.round(new Date().getTime() / 1000) + '.png';
          await that.ElectronService.FS.writeFile(that.ElectronService.USER_PATH + '/Thumbs/' + title, base64Url, 'base64', function (err, data) {
            if (err) {
              console.log('err', err);
            }
          });
          var url = "/assets/Nooor/" + that.ElectronService.USER_ID + '/Thumbs/' + title;
          await that.updatePageContentWithUrl(enrichmentObj, url);
          that.addingTabs(tabData, enrichmentObj);
        });
      });
    } else {
      if (this.currentPageNumber > 116)
        var url = "http://hyd.semanoor.com/NooorM/pdfImages/116.png";
      else
        var url = "http://hyd.semanoor.com/NooorM/pdfImages/" + this.currentPageNumber + ".png";
      this.updatePageContentWithUrl(enrichmentObj, url);
      this.addingTabs(tabData, enrichmentObj);
    }
  }


  async updatePageContentWithUrl(enrichmentObj, url) {
    var pageContent: PageContent = new PageContent();
    var liquidModel: LiquidModel = new LiquidModel();
    pageContent._id = Constants.USER + "." + enrichmentObj.id + ".pageContent";
    liquidModel.pageBgStyle = { "type": "image", "url": url, aspectRatio: true };
    pageContent.pageContent = liquidModel;
    pageContent.bookDocId = this.bookDataObj.bookDocId;
    this.epageContent = pageContent.pageContent;
    enrichmentObj.contentDocId = pageContent._id;
    enrichmentObj.description.url = url;
    await this.pouchService.createPageContentDoc(pageContent);
  }

  updatePageContentWithPage(enrichmentObj) {
    switch (this.pageObj.type) {
      case "youtube":
        enrichmentObj.description.url = this.pageObj.description.url;
        enrichmentObj.description.key = this.pageObj.description.key;
        break;
      case "internet":
      case "spreadSheet":
      case "googleDocs":
      case "presentation":
        enrichmentObj.description.url = this.pageObj.description.url;
        break;
      default:
        this.updatePageContent(enrichmentObj, this.pageObj.contentDocId);
        break;
    }
  }

  addGlobalLevelTabs(tabData, enrichmentObj) {
    //for first level tabs adding
    if (this.addTabtype == "firstLevelGlobal") {
      var count = this.findCount(this.tabsList, tabData);
      enrichmentObj.index = this.tabsList.length;



      // enrichmentObj.type = tabData.type;
      enrichmentObj.isService = tabData.isService;
      if (count + 1 > 0) {
        enrichmentObj.title = tabData.text + ' ' + (count + 1);
      }

      this.tabsList.push(enrichmentObj);
      this.firstLevel_selectedTabIndex = this.tabsList.length - 1;
      this.CurrentSelectedObj = this.tabsList[this.firstLevel_selectedTabIndex];
      this.currentSelectedParentObj = {};
      this.parentItems = [];
      this.addChromeTab(enrichmentObj, 'addChild', 'firstLevel', true);
    } else {

      var count = this.findCount(this.CurrentSelectedObj.children, tabData);


      enrichmentObj.index = this.CurrentSelectedObj.children.length;
      //enrichmentObj.type = tabData.type;
      enrichmentObj.isService = tabData.isService;
      enrichmentObj.level = this.CurrentSelectedObj.level + 1;
      if (count + 1 > 0) {
        enrichmentObj.title = tabData.text + ' ' + (count + 1);
      }

      this.CurrentSelectedObj.children.push(enrichmentObj);
      this.addChromeTab(enrichmentObj, 'addChild', 'secondLevel', true);

      //To update child count in first level
      if (enrichmentObj.level == 1) {
        document['chromeTabs'].showChildrenCount(this.CurrentSelectedObj.children.length);
      }

    }
  }

  //For adding child level tabs
  addChildTabs(tabData, tempObj) {

    var count = this.findCount(this.CurrentSelectedObj.children, tabData);

    //tempObj.id = Math.floor(Date.now() / 1000);
    tempObj.index = this.CurrentSelectedObj.children.length;
    //tempObj.type = tabData.type;
    tempObj.level = this.CurrentSelectedObj.level + 1;
    if (count + 1 > 0) {
      tempObj.title = tabData.text + ' ' + (count + 1);
    }

    tempObj.isService = tabData.isService;
    this.CurrentSelectedObj.children.push(tempObj);
    this.parentItems.push(this.CurrentSelectedObj);

    if (tempObj.level == 1) {
      document['chromeTabs'].showChildrenCount(this.CurrentSelectedObj.children.length);
    }
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
    this.loadSecondLevelChromeTabs(this.CurrentSelectedObj.children.length - 1);
  }

  //For adding sibling tabs
  addSiblingTabs(tabData, tempObj) {

    //tempObj.id = Math.floor(Date.now() / 1000);
    //tempObj.type = tabData.type;
    tempObj.isService = tabData.isService;

    //for first level tabs adding
    if (this.addTabtype == "firstLevelChild") {

      tempObj.index = this.tabsList.length;

      var count = this.findCount(this.tabsList, tabData);
      if (count + 1 > 0) {
        tempObj.title = tabData.text + ' ' + (count + 1);
      }

      if (this.tabAttachType == "addSiblingLeft") {
        this.tabsList.splice(this.firstLevel_selectedTabIndex, 0, tempObj);
        this.CurrentSelectedObj = this.tabsList[this.firstLevel_selectedTabIndex];
      }
      else if (this.tabAttachType == "addSiblingRight") {
        this.tabsList.splice(this.firstLevel_selectedTabIndex + 1, 0, tempObj);
        this.firstLevel_selectedTabIndex = this.firstLevel_selectedTabIndex + 1;
        this.CurrentSelectedObj = this.tabsList[this.firstLevel_selectedTabIndex];
      }
      this.addChromeTab(tempObj, this.tabAttachType, 'firstLevel', true);
    }
    //for nth level tabs adding
    else {
      tempObj.level = this.CurrentSelectedObj.level + 1;
      tempObj.index = this.CurrentSelectedObj.children.length;

      var count = this.findCount(this.CurrentSelectedObj.children, tabData);
      if (count + 1 > 0) {
        tempObj.title = tabData.text + ' ' + (count + 1);
      }

      if (this.tabAttachType == "addSiblingLeft") {
        this.CurrentSelectedObj.children.splice(this.activeSublevelIndex, 0, tempObj);
      }
      else if (this.tabAttachType == "addSiblingRight") {
        this.CurrentSelectedObj.children.splice(this.activeSublevelIndex + 1, 0, tempObj);
        this.activeSublevelIndex = this.activeSublevelIndex + 1;
      }
      this.addChromeTab(tempObj, this.tabAttachType, 'secondLevel', true);

      //To update child count in first level
      if (tempObj.level == 1) {
        document['chromeTabs'].showChildrenCount(this.CurrentSelectedObj.children.length);
      }
    }
    this.currentLoadingPage = tempObj;
  }

  //To fin the count of each type
  findCount(arr, tabData) {
    var count = 0;
    var occurences = arr.reduce(function (n, val) {
      if (val.title.indexOf(tabData.text) >= 0) {
        count++
      }
    }, 0);
    return count;
  }

  emptyChromeTabContent(level) {
    if (level == 'firstLevel') {
      document['chromeTabs'].emptyChromeTabContent();
    }
    else {
      document['chromeTabs2'].emptyChromeTabContent();
    }
  }

  firstLevelTabsConClick() {
    // this.renameFirstLevelTabIndex = undefined;
    // this.renameModel = "";
  }

  secondLevelTabsConClick() {
    // this.renameSecondLevelTabIndex = undefined;
    // this.renameModel = "";
  }

  initializeChromejs(elem, level) {
    var ref = this;
    if (level == 'firstLevel') {
      document['chromeTabs'].init(elem, {
        tabOverlapDistance: 14,
        minWidth: 45,
        maxWidth: 243
      })
    }
    else {
      document['chromeTabs2'].init(elem, {
        tabOverlapDistance: 14,
        minWidth: 45,
        maxWidth: 243
      })
    }
  }

  // reset() {
  //   this.renameFirstLevelTabIndex = undefined;
  //   this.renameSecondLevelTabIndex = undefined;
  //   this.renameModel = "";
  // }

  secondLevelTabsClick(ind, obj) {

    this.activeSublevelIndex = ind;
    this.activeCurrentLoadingPage = false;

    this.currentLoadingPage = obj;
    this.getPageCotent();
    this.emitCallback();
  }

  parentItemsClick(obj, ind) {

    if (ind == 0) {
      return;
    }

    this.displayList = false;

    this.parentItems = this.parentItems.splice(0, this.parentItems.length - ind);

    this.CurrentSelectedObj = obj;
    this.currentLoadingPage = obj.children[0];
    this.activeSublevelIndex = 0;
    this.activeCurrentLoadingPage = false;

    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
    this.loadSecondLevelChromeTabs(0);

    this.emitCallback();
  }

  showListviewTabs(popupParams, ev, width, height): void {
    this.cdr.detectChanges();

    if (this.parentItems.length > 1) {
      popupParams.loadDirective = ParentviewComponent;
      this.globalPopupPara = popupParams;
      this.globalPopupPara.showPopup = true;
      this.globalPopupPara.ev = ev;
      popupParams.showPopup = true;
      popupParams.height = height;
      popupParams.width = width;
      popupParams.arrowPos = 30;
      popupParams.direction = "top";

      if (document.getElementsByClassName("globalpopup")[0]) {
        document.getElementsByClassName("globalpopup")[0]["style"].height =
          "auto";
      }
    }

    this.cdr.detectChanges();

  }

  goToChildTabsList(ev, tabObj, state, i) {
    this.displayChildsOnSelection = true;
    ev.stopPropagation();
    if (state) {
      this.activeSublevelIndex = i;
    } else {
      //To handle second level content on first level tab child click
      this.parentItems = [];
      this.displayChildsOnSelection = true;
      this.firstLevel_selectedTabIndex = i;
      this.rootTabActive = false;
    }
    this.parentItems.push(tabObj);
    this.CurrentSelectedObj = this.parentItems[this.parentItems.length - 1];
    this.currentLoadingPage = tabObj;
    this.activeSublevelIndex = undefined;
    this.activeCurrentLoadingPage = true;
    this.cdr.detectChanges();
    this.loadSecondLevelChromeTabs(0);
    return false;
  }

  loadSecondLevelChromeTabs(secondLvlInd) {

    var _ref = this;

    this.displayChildsOnSelection = true;

    this.cdr.detectChanges();

    setTimeout(() => {
      _ref.el2 = document.querySelector('.chrome-tabs-secondLevel');
      if (_ref.el2 != null) {
        _ref.initializeChromejs(_ref.el2, 'secondLevel');
        _ref.setupEventHandlers(_ref.el2);
      }
    }, 10);

    //To add chrome tabs second level tabs onload
    setTimeout(() => {
      if (_ref.el2 != null) {
        _ref.emptyChromeTabContent('secondLevel');
        for (var j = 0; j <= _ref.CurrentSelectedObj.children.length; j = j + 1) {
          if (_ref.CurrentSelectedObj.children[j]) {
            _ref.addChromeTab(_ref.CurrentSelectedObj.children[j], "addChild", 'secondLevel', false);
          }
        }
        if (secondLvlInd != undefined) {
          document['chromeTabs2'].setCurrentTabAfterReAdding(secondLvlInd);
        }
      }
    }, 150);
  }

  loadFirstLevelChromeTabs() {

    //To add chrome tabs onload
    var _ref = this;

    setTimeout(() => {
      _ref.el = document.querySelector('.chrome-tabs');
      if (_ref.el != null) {
        _ref.initializeChromejs(_ref.el, 'firstLevel');
        _ref.setupEventHandlers(_ref.el);
      }
    }, 0)

    setTimeout(() => {
      if (_ref.el != null) {
        _ref.emptyChromeTabContent('firstLevel');
        if (_ref.tabsList && _ref.tabsList.length > 0) {
          for (var j = 0; j <= _ref.tabsList.length; j = j + 1) {
            if (_ref.tabsList[j]) {
              _ref.addChromeTab(_ref.tabsList[j], 'addChild', 'firstLevel', false);
            }
          }
        }
        else {
          _ref.setAddTabLeftPos();
        }
      }
    }, 150)

  }

  changeActiveToParent(obj, ev) {
    this.activeSublevelIndex = undefined;
    this.currentLoadingPage = obj;

    this.activeCurrentLoadingPage = true;

    if (this.parentItems.length - 1 > 0) {

      this.parentItems = this.parentItems.slice(0, this.parentItems.length - 1);
      this.CurrentSelectedObj = this.parentItems[this.parentItems.length - 1];
      this.activeSublevelIndex = this.CurrentSelectedObj.children.findIndex(el => el.id === obj.id);
      this.currentLoadingPage = obj;
    } else {
      this.CurrentSelectedObj = this.parentItems[0];
      this.parentItems = [];
      this.displayChildsOnSelection = false;
    }
    this.cdr.detectChanges();
    this.loadSecondLevelChromeTabs(this.activeSublevelIndex);
    this.emitCallback();
  }

  selectFirstLevelTab(obj, ind) {
    this.rootTabActive = false;
    this.firstLevel_selectedTabIndex = ind;
    this.currentLoadingPage = obj;
    this.displayChildsOnSelection = false;
    this.currentSelectedParentObj = {};
    this.CurrentSelectedObj = obj;
    this.parentItems = [];

    //test purpose - Added for new implementation
    this.parentItems.push(this.CurrentSelectedObj);

    this.getPageCotent();
    this.emitCallback();
  }


  getPageCotent() {
    if (this.currentLoadingPage.type == 'blankPage' || this.currentLoadingPage.type == 'pageFromBook' || this.currentLoadingPage.type == 'template' || this.currentLoadingPage.type == 'duplicateAsImage') {
      if (this.currentLoadingPage.contentDocId.length) {
        this.pouchService.getPageContent(this.currentLoadingPage.contentDocId);
      }
    }
  }

  gotoEnrichmentPage(data, event) {

    data.splice(0, 1);

    var self = this;
    this.parentItems = [];
    this.reloadEnrichments = false;
    this.rootTabActive = false;
    setTimeout(() => {
      self.reloadEnrichments = true;

      this.updateClickedPage(parseInt(data[0].data.title.split(' ')[1]) - 1);

      if (data[0].data) {
        //To select tab in the first level
        let ind = self.tabsList.findIndex(obj => obj.id == data[0].data.id)
        if (ind != -1) {

          document['chromeTabs'].setCurrentTab(document['chromeTabs'].tabEls[ind]);

          setTimeout(() => {
            document['chromeTabs'].tabEls[ind].classList.add('chrome-tab-current');

          }, 200);


          //To push items in to parentItems
          this.parentItems = [];
          for (var k = 0; k < data.length - 1; k = k + 1) {
            self.parentItems.push(data[k].data);
          }
          //To load second level tabs and select the corresponding second level tab
          if (data[data.length - 2]) {
            self.displayChildsOnSelection = true;
            self.CurrentSelectedObj = self.searchTabsList(self.tabsList[ind], data[data.length - 2].data.id);
            if (self.CurrentSelectedObj && self.CurrentSelectedObj != null) {
              let index = self.CurrentSelectedObj.children.findIndex(obj => obj.id == data[data.length - 1].data.id)
              if (index != -1) {
                this.cdr.detectChanges();
                self.loadSecondLevelChromeTabs(index);
              }
            }
          }
        }
      }

      this.cdr.detectChanges();
    }, 10);

  }

  searchTabsList(element, id) {
    if (element.id == id) {
      return element;
    } else if (element.children != null) {
      var i;
      var result = null;
      for (i = 0; result == null && i < element.children.length; i++) {
        result = this.searchTabsList(element.children[i], id);
      }
      return result;
    }
    return null;
  }

  updateClickedPage(pdfInx) {

    var obj = {
      "pdfInx": pdfInx,
      "state": 'pagesIndex'
    }

    this.rootTabActive = false;
    this.rootTabClick('');
    // this.notify.emit(obj);
    this.currentPageNumber = pdfInx + 1;
    this.cdr.detectChanges();

  }

  openDialog(): void {

    var ref = this;

    let dialogRef = this.dialog.open(CreateTemplateDialogueComponent, {
      width: '315px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        // var timestamp = Math.floor(Date.now() / 1000);
        var timestamp = Constants.getGUID();
        var pageTemplate: PageTemplate = new PageTemplate();
        pageTemplate._id = Constants.USER + "." + timestamp + ".pageTemplate";
        // pageTemplate.contentDocId = ref.CurrentSelectedObj.contentDocId;
        pageTemplate.contentDocId = ref.currentLoadingPage.contentDocId;
        pageTemplate.name = result;
        ref.EBEpouchdbService.createTemplate(pageTemplate);
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/enrichmentTabs.component.ts